var exports = {
  "s": "PreviewCardOutlet__P1j7ms",
};

module.exports = exports;
